import { render, staticRenderFns } from "./CategoryEdit.vue?vue&type=template&id=6852f478&scoped=true"
import script from "./CategoryEdit.vue?vue&type=script&lang=js"
export * from "./CategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./CategoryEdit.vue?vue&type=style&index=0&id=6852f478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6852f478",
  null
  
)

export default component.exports